import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Shell for the COMPANY panel's Challenges insights section. Title, mode
 * badge, page dropdown and department filter all come from
 * CompanySectionLayout, shared with Sleep, Breathwork, Habits and Perks.
 *
 * Analytics only — creating and editing challenges stays on /:slug/challenges,
 * where the sidebar still points. This section lives one level down at
 * /:slug/challenges/insights, the same split Marketplace uses.
 */
const CompanyChallengesLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';
  const person = population.replace(/s$/, '');

  const pages = [
    {
      label: 'Overview',
      path: `/${slug}/challenges/insights`,
      description: 'Participation, completion and the activity behind it'
    },
    {
      label: 'Challenges',
      path: `/${slug}/challenges/insights/challenges`,
      description: 'Every challenge you ran, and how it performed'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/challenges/insights/users`,
      description: `Per-${person} challenge records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Challenges"
      subtitle={`How many of your ${population} take part in your challenges, and how far they get.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyChallengesLayout;
